<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  import { useData } from "$lib/state/data.svelte.js";
  import { GEO_LEVELS } from "$utils/consts.js";
  import { BasicDropdown, Button, logClickToGA } from "@urbaninstitute/dataviz-components";
  import { RadioGroup, RadioItem } from "$components/Radio/index.js";
  import MetricLinks from "$components/Controls/MetricLinks.svelte";

  const data = useData();

  let levelData = [
    {
      value: GEO_LEVELS.STATE,
      label: data.labels.state_label
    },
    {
      value: GEO_LEVELS.DISTRICT,
      label: data.labels.district_label
    }
  ];

  let districtDropdownList = $derived(
    data.districtDropdownList.filter((district) => {
      let stateId = district.value.slice(0, 2);
      return stateId === data.currentState;
    })
  );

  let dollarList = [
    {
      value: "real",
      label: data.labels.real_dollar_label
    },
    {
      value: "nominal",
      label: data.labels.nominal_dollar_label
    }
  ];

  let districtDisabled = $derived(
    !data.currentChartData.some((layer) => layer.level === GEO_LEVELS.DISTRICT)
  );
</script>

<div class="sidebar-control-wrapper">
  <div class="control-item">
    <div class="control-label">Select a state:</div>
    <BasicDropdown
      bind:value={data.currentState}
      data={data.stateDropdownList}
      id="state-select"
      inlineLabel=""
      placeholder={null}
      on:change={(e) =>
        logClickToGA(/** @type {HTMLElement} */ (e.currentTarget), "state-selected-sidebar")}
      dropdownWidth={200}
    />
  </div>
  <div class="control-item">
    <div class="control-label">Data level:</div>
    <RadioGroup
      bind:value={data.currentLevel}
      onValueChange={(/** @type {string} */ e) => {
        logClickToGA(
          /** @type {HTMLElement} */ (/** @type {unknown} */ (null)),
          `geo-level-select-${e}`
        );
      }}
    >
      {#each levelData as { value, label }}
        {@const disabled = !data.levelMap.get(/** @type {any} */ (data.currentMetric))?.has(value)}
        <RadioItem {value} {label} {disabled}></RadioItem>
      {/each}
    </RadioGroup>
  </div>
  {#if data.currentLevel === "district" && !districtDisabled}
    <div class="control-item">
      <div class="control-label">Select a congressional district:</div>
      <BasicDropdown
        bind:value={data.currentDistrict}
        data={districtDropdownList}
        id="district-select"
        inlineLabel=""
        on:change={(e) =>
          logClickToGA(/** @type {HTMLElement} */ (e.currentTarget), "district-selected-sidebar")}
        dropdownWidth={200}
      />
    </div>
  {/if}
  {#if data.isCurrentMetricDollar}
    <div class="control-item">
      <div class="control-label">{data.labels.currency_control}</div>
      <RadioGroup bind:value={data.currentDollarType}>
        {#each dollarList as { value, label }}
          <RadioItem {value} {label}></RadioItem>
        {/each}
      </RadioGroup>
    </div>
  {/if}
  <MetricLinks />
</div>

<style>
  .control-item {
    margin-bottom: var(--spacing-8);
  }
  .control-label {
    font-weight: var(--font-weight-bold);
    margin-bottom: var(--spacing-2);
    font-family: var(--font-family-sans-alt);
  }
  .sidebar-control-wrapper :global(button.radio-radio:focus:not(:focus-visible)) {
    outline: 0 !important;
  }
  .sidebar-control-wrapper :global(button.radio-radio:focus-visible) {
    outline: 2px solid var(--color-blue-shade-darker) !important;
    outline-offset: 2px !important;
  }

  .sidebar-control-wrapper :global(.dropdown-container select:focus:not(:focus-visible)) {
    outline: 0 !important;
  }
  .sidebar-control-wrapper :global(.dropdown-container select:focus-visible) {
    outline: 2px solid var(--color-blue-shade-darker) !important;
    outline-offset: 2px !important;
  }
  .desktop-only {
    display: none;
  }
  @media (min-width: 1024px) {
    .desktop-only {
      display: block;
    }
    .mobile-controls {
      display: none;
    }
  }
</style>
